import React, { FunctionComponent, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.snow.css'
import './index.less'

const modules = {
	toolbar: [
		[{ header: [1, 2, false] }],
		['bold', 'italic', 'underline'],
		[{ list: 'ordered' }, { list: 'bullet' }],
		['clean'],
	],
}

type TProps = {
	value?: string
	placeholder?: string
	error?: string
	disabled?: boolean
	onChange?: (value: string) => void
}

const Wysiwyg: FunctionComponent<TProps> = (props) => {
	const [className, setClassName] = useState<string>('')

	useEffect(() => {
		setClassName(props.error ? 'error' : '')
	}, [props.error])

	return (
		<ReactQuill
			value={props.value || ''}
			className={`wysiwyg ${className}`}
			placeholder={props.placeholder}
			onChange={props.onChange}
			modules={modules}
		/>
	)
}

export { Wysiwyg }
